module.exports = __webpack_public_path__ + "img/about-pic1.92e4578f.png";